<template>
  <div class="DetailBody">
    <h1 v-if="title" class="mb-1 text-xs text-gray-500">{{ title }}</h1>
    <div
      v-a-blank-target
      v-iframe-container
      v-img-clickable
      class="DetailBodyText"
      :class="{
        'has-title': title,
        'is-collapse': showMore,
        'is-edited': edited
      }"
      v-html="linkifiedText"
    />
    <span v-if="edited" class="block mb-12 italic text-gray-500 text-xxs">
      Edited by {{ getUserByID(edited.user).username }}
      {{ edited.date | dateFromNow }} ago
    </span>
    <div v-if="!disableShowMore && showMore" class="ShowMore">
      <div class="Separator">
        <lm-icon-button
          icon="keyboard_arrow_down"
          label="Show more"
          @click="showMore = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import linkifyHtml from 'linkifyjs/html'
import {mapGetters} from 'vuex'
import LmIconButton from '@/components/ui/LmIconButton'

export default {
  name: 'LmDetailBody',
  components: {LmIconButton},
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: ''
    },
    edited: {
      type: Object,
      default: null
    },
    disableShowMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMore: false
    }
  },
  computed: {
    ...mapGetters(['getUserByID']),
    linkifiedText() {
      return this.text ? linkifyHtml(this.text) : ''
    }
  },
  watch: {
    text() {
      this.showMore = false
      this.$nextTick(() => this.updateShowMore())
    }
  },
  mounted() {
    this.updateShowMore()
  },
  methods: {
    updateShowMore() {
      if (this.disableShowMore) return
      this.showMore = this.$el.offsetHeight >= 250
    }
  }
}
</script>

<style scoped>
.DetailBody {
  position: relative;
}
.DetailBodyText {
  margin: 24px 0 48px;
  &.has-title {
    margin: 0 0 24px 0;
  }
  &.is-collapse {
    height: 300px;
    margin-bottom: 24px;
    overflow-y: hidden;
  }
  &.is-edited {
    margin: 24px 0 8px 0;
  }
}
.ShowMore {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: white;
  background: linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 1)
  );
}
.Separator {
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 67px;
  z-index: 1;
  text-align: center;
  color: theme('colors.gray.500');
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 55%;
    width: 100%;
    z-index: -2;
    border-bottom: 1px solid theme('colors.gray.500');
  }
  .LmIconButton {
    padding: 4px 8px 4px 4px;
    border: 1px solid theme('colors.gray.500');
    color: theme('colors.gray.700');
    background: white;
    font-size: 12px;
    &:hover {
      color: theme('colors.gray.900');
      border-color: theme('colors.gray.500');
    }
  }
}
</style>
<style>
.DetailBodyText {
  p:first-child {
    margin-top: 0;
  }
}
</style>
